import { Colors } from "src/com/sixdee/crbtportal/utils/resources/colors";
import { Fonts } from "src/com/sixdee/crbtportal/utils/resources/fonts";
import { SelectCSSStyleImpl } from "../selectcss";

export class ProfileTuneSelectCSSStyleImpl extends SelectCSSStyleImpl
{
  
    getWrapperCSSStyle(): object 
    {
        return {
            width:"100%",
            // display: "flex",
            // position: "relative",
            // flexDirection: "column",
            marginTop: "0px",
        };
    }

    getSelectLabelCSSStyle():object
    {
        return{
            height:'20px',
            lineHeight:'20px',
            color:this.getResources().getColor(Colors.color_7),
            textAlign:"left",
            fontSize:this.getResources().getFont(Fonts.h7)
        };
    }
    getLabelStartCSSStyle():object
    {
        return{
            color:this.getResources().getColor(Colors.color_25)
        };
    }
    getTextCSSStyle(isFloatingLabel: boolean, isDisabled:boolean): object 
    {
    
            return {
                fontSize: this.getResources().getFont(Fonts.h9),
                color: this.getResources().getColor(Colors.color_4),
                height: "60px",
                // bottom: "3px",
                width:"85%",
                textDecoration: "none",
                fontWeight: 500,
                letterSpacing: 0,
                lineHeight: "40px",
                border:'1px solid '+this.getResources().getColor(Colors.color_8),
                outline: "none",
                paddingLeft: "5px",
                paddingRight: "5px",
                backgroundColor:isDisabled? this.getResources().getColor(Colors.color_17): this.getResources().getColor(Colors.color_5),
                boxSizing: "border-box"

            };
      
    }

    getErrorCSSStyle(): object {
        return {
            fontSize: this.getResources().getFont(Fonts.h7),
            color: this.getResources().getColor(Colors.color_4),
            height: "40px",
            // bottom: "3px",
            textDecoration: "none",
            fontWeight: 500,
            letterSpacing: 0,
            lineHeight: "40px",
            border:'1px solid '+this.getResources().getColor(Colors.color_8),
            outline: "none",
            paddingLeft: "15px",
            paddingRight: "15px",
            backgroundColor: this.getResources().getColor(Colors.color_5),
            boxSizing: "border-box",
            // borderLeft: "2px solid " + this.getResources().getColor(Colors.color_12),
        };
    }

    getErrorTextDivCSSStyle(): object 
    {
        return {
           display: "flex"
        };
    }

    getErrorTextCSSStyle(language:any): object {
        return {
            color: this.getResources().getColor(Colors.color_12),
            fontSize: this.getResources().getFont(Fonts.h5),
            margin:'5px 0px 0px auto'
        };
    }

    getDropDownSSStyle(): object 
    {
        return {
            display: "flex",
            marginTop: "0px",
            position: "absolute",
            zIndex: 2,
            marginLeft:"4px",
            borderRadius:'0px 0px 8px 8px',
            border: '1px solid #EAECEF',
            backgroundColor: this.getResources().getColor(Colors.color_5)
        };
    }

}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/select/profiletuneselect/profiletuneselectcss.tsx